const EmployeeFooter = (props) => {
  return (
    <></>
  );
}
export default EmployeeFooter;